import React from "react";
import classNames from "classnames";
import CollapsedPackageRow from "./CollapsedPackageRow";
import "./PackageCard.css";
import { isAdminUser } from "../../../../services/authService";
import "./PackageTable.scss";
import { convertPrice } from "../../../../services/currencyService";
import LocationMap from "../../../../Pages/Client/HotelProfile/Components/LocationMap/locationmap";
import { GoogleMapSecretKey } from "../../../../assets/GlobalVariables";
import { useTranslation } from "react-i18next";
import hotelSVG from "../../../../assets/images/card/hotel.svg";
import arrowDownSVG from "../../../../assets/images/card/arrow-down.svg";

const DatesCellRender = ({ checkIn, checkOut }) => {
  return (
    <div>
      {checkIn} - {checkOut}
    </div>
  );
};

const HotelName = ({ name }) => {
  return <div className="blue-name-cell">{name}</div>;
};

const SumPaid = ({ sum }) => {
  return (
    <div className={classNames("sum-paid", { positive: sum > 0 })}>
      {convertPrice(sum || 0)}
    </div>
  );
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
};

const PackageCard = ({ row, index, cancelOrder, orders, setOrders } = {}) => {
  const translate = useTranslation();

  const isAdmin = isAdminUser();
  // console.log("PackageRow", row);

  const mainContact = row?.passengersinfo?.[0]?.adults?.[0];

  const mainContactName = `${mainContact?.title}  ${mainContact?.firstname}  ${mainContact?.lastname}`;

  const ourTotalFareForAllRoomsNIS = row?.ourprice?.priceWithCreditCardFee || 0; //TODO:fix this

  const [hotelImage, setHotelImage] = React.useState(null);
  const [hotelLongLat, setHotelLongLat] = React.useState(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const [hotel, setHotel] = React.useState(null);
  const [flights, setFlights] = React.useState(null);

  const { pending, cancelled, paid, order_response, bank_transfer } = row;

  async function getGeolocation(address) {
    try {
      // const language = localStorage.getItem('i18nextLng') ? localStorage.getItem('i18nextLng') : 'he';
      const language = "en";

      const encodedAddress = encodeURIComponent(address);
      const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${GoogleMapSecretKey}&language=${language}`;

      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data.status === "OK" && data.results.length > 0) {
        const result = data.results[0];
        const country = result.address_components.find((component) =>
          component.types.includes("country")
        ).long_name;

        const location = result.geometry.location;
        const latitude = location.lat;
        const longitude = location.lng;

        return { country, latitude, longitude };
      } else {
        throw new Error("Unable to retrieve geolocation data");
      }
    } catch (error) {
      console.error("Error fetching geolocation:", error.message);
      throw error;
    }
  }

  React.useEffect(() => {
    if (!order_response || !order_response.reservation) return;
    const { hotel, flights } = order_response.reservation;
    if (hotel) {
      setHotel(hotel);
      const { resourceUrl, hotelName, hotelCity, location } = hotel;
      const fetchData = async () => {
        try {
          if (resourceUrl) {
            setHotelImage(resourceUrl);
          }

          if (location) {
            const result = await getGeolocation(location);
            // setHotelCountry(result.country);
            setHotelLongLat({ lat: result.latitude, lng: result.longitude });
          }
        } catch (error) {
          console.error("Error:", error.message);
        }
      };
      fetchData();
    }
    if (flights) {
      setFlights(flights);
    }
  }, [order_response]);

  if (hotel == null && flights == null) return null;
  return (
    <React.Fragment>
      <div className="card">
        <div
          className={
            "order-status" +
            (cancelled ? " cancelled" : paid ? " paid" : " pending")
          }
        >
          {cancelled
            ? "בוטלה"
            : pending
              ? "ממתינה לאישור ספק"
              : paid
                ? "שולמה"
                : bank_transfer
                  ? "ממתינה להעברה בנקאית"
                  : "ממתינה לתשלום"}
        </div>
        <div className="image-and-map">
          <img className="image" src={hotelImage} alt={hotel?.hotelName} />
          {hotelLongLat != null ? (
            <div className="map">
              <LocationMap
                lat={hotelLongLat.lat}
                lng={hotelLongLat.lng}
                mapId={"map-" + index}
              />
            </div>
          ) : null}
        </div>
        <div
          className={"info-open-card" + (isOpen ? " open" : "")}
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <div className="info">
            <div className="icon-name-date">
              <img className="icon" src={hotelSVG} alt="hotel" />
              <div className="name-and-dates">
                <div className="name">
                  <HotelName name={hotel?.hotelName || ""} />
                </div>
                <div className="dates">
                  <DatesCellRender
                    checkIn={hotel?.checkInDate}
                    checkOut={hotel?.checkOutDate}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="open-text">
            <div className="text">
              {isOpen
                ? translate.t("hotelcard.closecard")
                : translate.t("hotelcard.opencard")}
            </div>
            <img className="icon" src={arrowDownSVG} alt="open/close" />
          </div>
        </div>
        {isOpen ? (
          <CollapsedPackageRow
            orders={orders}
            setOrders={setOrders}
            cancelOrder={cancelOrder}
            row={row}
            index={index}
          />
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default PackageCard;
